var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    _vm._position,
    _vm._size,
    _vm._hidden,
    {darkmode: _vm.darkmode}],attrs:{"id":"qrbox"}},[_c('div',{staticClass:"top"},[_c('div',{staticClass:"scan-me"},[_vm._v(" "+_vm._s(_vm.$t('system.scanMe'))+" ")]),_c('div',{staticClass:"qr"},[_c('VueQRCodeComponent',{attrs:{"text":_vm.fullurl,"error-level":"L"}})],1)]),_c('div',{staticClass:"bottom"},[_vm._v(_vm._s(_vm.shorturl))])])
}
var staticRenderFns = []

export { render, staticRenderFns }